import { usePrimaryProduct } from '../../../../controllers/store/bootstrap';
import { useFilters, useFiltersToDisplay } from '../../../../controllers/store/search';
import { siteFilterId } from '../../../../controllers/store/search/filters/filter-ids';
import { useMaxInlineFilters } from './row-width';

// Width only decides how many of the store's inline ids fit; it never re-runs the partition.
export const useRefreshFilterPlacement = (): {
	filtersInLine: string[];
	filtersInDropdown: string[];
} => {
	const [primaryProduct] = usePrimaryProduct();
	const [{ filtersInLine, filtersInDropdown }] = useFiltersToDisplay({
		basedOnPrimaryProduct: false,
		useDisjointFilterPlacement: true,
		primaryProduct,
	});
	const maxInlineFilters = useMaxInlineFilters();
	const allFilters = useFilters();

	// Dropdown order: select filters, then boolean filters, then site (always last, never inline).
	const orderDropdown = (ids: string[]) => {
		const withoutSite = ids.filter((id) => id !== siteFilterId);
		const isBoolean = (id: string) => allFilters[id]?.type === 'boolean';
		return [
			...withoutSite.filter((id) => !isBoolean(id)),
			...withoutSite.filter(isBoolean),
			siteFilterId,
		];
	};

	if (maxInlineFilters === undefined) {
		return { filtersInLine, filtersInDropdown: orderDropdown(filtersInDropdown) };
	}

	return {
		filtersInLine: filtersInLine.slice(0, maxInlineFilters),
		filtersInDropdown: orderDropdown([
			...filtersInLine.slice(maxInlineFilters),
			...filtersInDropdown,
		]),
	};
};
